import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private reqCount = 0;
  private _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  constructor(private ngZone: NgZone) {}

  show() {
    this.reqCount++;
    this.ngZone.run(() => {        
      this._loading.next(true);
    });
  }

  hide() {
    this.reqCount--;
    if (this.reqCount === 0) {
      this.ngZone.run(() => {       
        this._loading.next(false);
      });
    }
  }
}
